export default __webpack_public_path__ + "static/media/Stamps.a9f6a2b0.png";